import { UserRoleType } from '@zspace/types';
import useUser from './user';

export function useUserHasZspaceInternalAndCustomerRoles() {
  const { user: currentUser } = useUser();
  
    let hasZspaceInternalRole = false;
    let hasCustomerRole = false;
    currentUser.roles.forEach((roleAssignment) => {
      switch (roleAssignment.role.name) {
        case UserRoleType.ZSPACE_INTERNAL:
          hasZspaceInternalRole = true;
          break;
        case UserRoleType.CUSTOMER:
          hasCustomerRole = true;
          break;
      }
    });
    return hasZspaceInternalRole && hasCustomerRole;
}

export default useUserHasZspaceInternalAndCustomerRoles;
